module.exports = __webpack_public_path__ + "static/media/coffee-kin.653403b6.jpg";